module.exports = {
  "country": "ES",
  "artist": "Beth ",
  "song": "Dime",
  "year": "2003",
  "place": "8",
  "spotify": "7Cf4bpnB164MgYLCPWd88h"
};